import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["pageParam"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import getMarketplace from "../../../../../../global-config/get-marketplace";
import getWishlistQueryKey from "../../get-query-key";
var _getNextPageParam = function getNextPageParam(lastData) {
  var _lastData$pages;
  var next = lastData === null || lastData === void 0 || (_lastData$pages = lastData.pages) === null || _lastData$pages === void 0 ? void 0 : _lastData$pages.next;
  var match = next === null || next === void 0 ? void 0 : next.match(/[?&]anchor=(\d+)/); // extract anchor value from next page url. This is a simpler way to reason about the anchor value
  var anchorValue = null;
  if (match) {
    anchorValue = match[1];
  }
  return anchorValue;
};
export { _getNextPageParam as getNextPageParam };
export var fetchListItems = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id, pageParam, _yield$Promise$all, _yield$Promise$all2, marketplace, token;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id, pageParam = _ref.pageParam;
          _context.next = 1;
          return Promise.all([getMarketplace(), window.webShellClient.identity.getAccessToken()]);
        case 1:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          marketplace = _yield$Promise$all2[0];
          token = _yield$Promise$all2[1];
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/wishlists/v2/lists/").concat(id, "/items?marketplace=").concat(marketplace, "&anchor=").concat(pageParam, "&count=25"), {
            method: 'GET',
            credentials: 'include',
            headers: formatHeaders({
              token: token,
              appId: DOTCOM_UX_ID
            })
          }, 'Error getting list.'));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchListItems(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getFetchOptions = function getFetchOptions(_ref3) {
  var id = _ref3.id;
  return {
    queryKey: getWishlistQueryKey({
      id: id
    }),
    // Defaulted pageParam to 0 to start at the beginning of a user's wishlist
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var _ref4$pageParam, pageParam, rest;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref4$pageParam = _ref4.pageParam, pageParam = _ref4$pageParam === void 0 ? 0 : _ref4$pageParam, rest = _objectWithoutProperties(_ref4, _excluded);
              _context2.next = 1;
              return fetchListItems(_objectSpread({
                id: id,
                pageParam: pageParam
              }, rest));
            case 1:
              return _context2.abrupt("return", _context2.sent);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function queryFn(_x2) {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity,
    getNextPageParam: function getNextPageParam(lastData) {
      return _getNextPageParam(lastData);
    }
  };
};
export default getFetchOptions;